import {type GraphLegendLinkTarget} from './graphRenderProps';

/** The host chooses whether prepared run destinations are exposed. */
export function getLegendRunLink(
  target: GraphLegendLinkTarget
): string | undefined {
  return target.legendHref;
}
